export default __webpack_public_path__ + "static/media/cabifyImg.fc760e5c.png";